import * as React from 'react';
import { useEffect } from 'react';

import * as fullStory from 'js/lib/fullstory';
import user from 'js/lib/user';

import RecruitingProfileViewerWithProviders from 'bundles/account-profile/components/RecruitingProfileViewerWithProviders';
import { shouldEnableLearnerProfileEditFullStory } from 'bundles/account-profile/epicFeatureFlags';
import AuthenticationModal from 'bundles/authentication/shared/components/authentication-modal/AuthenticationModal';

export function EditProfileForm() {
  const isAuthenticated = user.isAuthenticatedUser();
  const userId = user.get()?.id ?? '';

  useEffect(() => {
    if (!isAuthenticated) {
      return;
    }

    if (shouldEnableLearnerProfileEditFullStory()) {
      fullStory.start({ disableForCourserians: true });
      fullStory.set({
        userId,
        employabilityAccountProfile: true,
      });
    }
  }, [userId, isAuthenticated]);

  // Whenever a user is on /account-profile they should require
  // authentication to see anything.
  // External account views are done in AccountProfileViewerPage elsewhere.
  if (!isAuthenticated) {
    return <AuthenticationModal utilizeWebRedirectOnClose onCloseRedirectURL="/" preventRegister />;
  }

  return <RecruitingProfileViewerWithProviders isEditMode={true} />;
}

export default EditProfileForm;
